import { useGameStore } from '@/store/gameStore';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

const phases = ['auction', 'battle', 'results'] as const;

export function PhaseBar() {
  const { phase } = useGameStore();
  const isOnline = useOnlineStatus();
  if (!(phases as readonly string[]).includes(phase)) return null;

  return (
    <div className="fixed top-3 left-1/2 -translate-x-1/2 z-40">
      <div className="flex items-center gap-2 rounded-full border border-border bg-secondary/80 px-3 py-1 text-xs font-display shadow-lg backdrop-blur">
        {phases.map((item, index) => {
          const isActive = phase === item;
          return (
            <div key={item} className="flex items-center gap-2">
              <span
                className={`uppercase tracking-wide ${
                  isActive ? 'text-primary font-semibold' : 'text-muted-foreground'
                }`}
              >
                {item}
              </span>
              {index < phases.length - 1 && (
                <span className="text-muted-foreground/60">›</span>
              )}
            </div>
          );
        })}
      </div>
      {!isOnline && (
        <div className="mt-2 rounded-full border border-warning/40 bg-warning/10 px-3 py-1 text-xs font-display text-warning text-center">
          Offline. Reconnecting...
        </div>
      )}
    </div>
  );
}
